import {
  Button,
  Divider,
  Drawer,
  Form,
  Input,
  Select,
  Space,
  Typography,
  Modal,
  InputNumber,
  DatePicker,
} from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import TextArea from "antd/es/input/TextArea";
import CreateNewRFID from "./CreateNewRFID";
import moment from "moment";

const EditEmployee = ({
  open,
  close,
  setLoading,
  rerun,
  selectedData,
  positionList,
  departmentList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadingsInfo, setLoadingsInfo] = useState(false);
  const [loadingsCred, setLoadingsCred] = useState(false);
  const { userData } = useContext(UserInfo);
  const [form] = Form.useForm();
  const [provinceList, setProvinceList] = useState({ data: [], ready: false });
  const [cityList, setCityList] = useState({ data: [], ready: false });
  const [barangayList, setBarangayList] = useState({ data: [], ready: false });
  const [createRFIDDiag, setCreateRFIDDiag] = useState(false);
  const [allowAttendance, setAllowAttendance] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(
    selectedData.salary_sched
  );

  const handleEditEmployee = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("merchant_uid", userData.data.merchant_uid);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadingsInfo(true);
    setLoading(true);
    axios
      .post("user/merchant/edit-employee", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Edited employee successfully.");
          setTimeout(() => {
            close();
            form.setFieldsValue({
              firstname: "",
              middlename: "",
              lastname: "",
              street: "",
              barangay: "",
              city: "",
              province: "",
              contact_no: "",
              position: "",
              department: "",

              salary_sched: "",
              salary_pay_count: "",
              amount: "",
              date_hired: "",
              date_stopped: "",
            });
            setLoadingsInfo(false);
            setLoading(false);
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadingsInfo(false);
      });
  };

  const handleEditEmployeeCredential = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("merchant_uid", userData.data.merchant_uid);
    formdata.append(
      "employee_user_id",
      selectedData !== null ? selectedData.user_id : ""
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadingsCred(true);
    setLoading(true);
    axios
      .post("user/merchant/edit-employee-credential", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Edited employee credentials successfully.");
          setTimeout(() => {
            close();
            setLoadingsCred(false);
            setLoading(false);
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadingsCred(false);
      });
  };

  const getAllProvinces = () => {
    axios
      .get("user/merchant/province-list")
      .then((response) => {
        const data = response.data;
        setProvinceList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleGetCityByProvince = (value) => {
    var params = { province_description: value };
    setCityList({ data: [], ready: false });
    setBarangayList({ data: [], ready: false });
    axios
      .get("user/merchant/city-list", { params })
      .then((response) => {
        const data = response.data;
        setCityList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleGetBarangayByCity = (value) => {
    var params = { city_municipality_description: value };
    setBarangayList({ data: [], ready: false });
    axios
      .get("user/merchant/barangay-list", { params })
      .then((response) => {
        const data = response.data;
        setBarangayList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getAllProvinces();

    userData.data.usersmerpermission.find(
      ({ permission }) => permission === "allow-store-attendance"
    )
      ? setAllowAttendance(true)
      : setAllowAttendance(false);
  }, []);

  return (
    <Drawer
      title="Edit Employee"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {/* {console.log("selectedData: ", selectedData)} */}
      {selectedData !== null && (
        <>
          <Form
            form={form}
            layout="vertical"
            name="edit-employee"
            initialValues={{
              firstname: selectedData.firstname,
              middlename:
                selectedData.middlename === null ? "" : selectedData.middlename,
              lastname: selectedData.lastname,
              street: selectedData.street,
              barangay: selectedData.barangay,
              city: selectedData.city,
              province: selectedData.province,
              contact_no: selectedData.contact_no,
              position: parseInt(selectedData.position),
              department:
                selectedData.department !== null
                  ? parseInt(selectedData.department)
                  : "",
              salary_sched: selectedData.salary_sched,
              salary_pay_count: selectedData.salary_pay_count,
              amount:
                selectedData.salary_sched === "daily"
                  ? selectedData.daily_amount
                  : selectedData.monthly_amount,
              date_hired:
                selectedData.date_hired !== null
                  ? moment(selectedData.date_hired)
                  : "",
              date_stopped:
                selectedData.date_stopped !== null
                  ? moment(selectedData.date_stopped)
                  : "",
            }}
            onFinish={handleEditEmployee}
            autoComplete="off"
          >
            <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
              <Typography
                style={{ marginBottom: 10, fontSize: 16, fontWeight: "bold" }}
              >
                INFORMATION
              </Typography>
              <Form.Item
                name="firstname"
                label="Firstname"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Set firstname" size="large" />
              </Form.Item>
              <Form.Item
                name="middlename"
                label="Middlename"
                rules={[
                  {
                    required: false,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Set middlename" size="large" />
              </Form.Item>
              <Form.Item
                name="lastname"
                label="Lastname"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Set lastname" size="large" />
              </Form.Item>

              <Form.Item
                name="province"
                label="Province"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select province"
                  onChange={handleGetCityByProvince}
                  size="large"
                  showSearch
                >
                  {provinceList.data.length > 0 ? (
                    provinceList.data.map((data, index) => (
                      <Select.Option
                        value={data.province_description}
                        key={index}
                      >
                        {data.province_description}
                      </Select.Option>
                    ))
                  ) : (
                    <Select.Option value="">No province found!</Select.Option>
                  )}
                </Select>
              </Form.Item>
              <Form.Item
                name="city"
                label="City"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select city"
                  onChange={handleGetBarangayByCity}
                  size="large"
                  showSearch
                >
                  {cityList.data.length > 0 ? (
                    cityList.data.map((data, index) => (
                      <Select.Option
                        value={data.city_municipality_description}
                        key={index}
                      >
                        {data.city_municipality_description}
                      </Select.Option>
                    ))
                  ) : (
                    <Select.Option value="">No city found!</Select.Option>
                  )}
                </Select>
              </Form.Item>
              <Form.Item
                name="barangay"
                label="Barangay"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select barangay"
                  size="large"
                  showSearch
                  style={{ textTransform: "uppercase" }}
                >
                  {barangayList.data.length > 0 ? (
                    barangayList.data.map((data, index) => (
                      <Select.Option
                        value={data.barangay_description}
                        key={index}
                        style={{ textTransform: "uppercase" }}
                      >
                        {data.barangay_description}
                      </Select.Option>
                    ))
                  ) : (
                    <Select.Option value="">No barangay found!</Select.Option>
                  )}
                </Select>
              </Form.Item>
              <Form.Item
                name="street"
                label="Street|House No.|Bldg. No.|Apartment"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <TextArea
                  placeholder="Set street|house no.|bldg. no.|apt"
                  autoSize
                  size="large"
                  style={{ textTransform: "uppercase" }}
                />
              </Form.Item>

              <Form.Item
                name="contact_no"
                label="Contact No."
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Set contact number" size="large" />
              </Form.Item>
              <Form.Item
                name="position"
                label="Position"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select position"
                  size="large"
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {positionList.data.length > 0 ? (
                    positionList.data.map((data, index) => (
                      <Select.Option value={data.id} key={index}>
                        {data.position}
                      </Select.Option>
                    ))
                  ) : (
                    <Select.Option value="">No position found!</Select.Option>
                  )}
                </Select>
              </Form.Item>

              <Form.Item
                name="department"
                label="Department"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select department"
                  size="large"
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {departmentList.data.length > 0 ? (
                    departmentList.data.map((data, index) => (
                      <Select.Option value={data.id} key={index}>
                        {data.department}
                      </Select.Option>
                    ))
                  ) : (
                    <Select.Option value="">No department found!</Select.Option>
                  )}
                </Select>
              </Form.Item>

              <Form.Item
                name="date_hired"
                label="Date Hired"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <DatePicker
                  format={"YYYY-MM-DD"}
                  size="large"
                  style={{ width: "100%" }}
                  // showTime
                />
              </Form.Item>

              <Form.Item
                name="date_stopped"
                label="Date Stopped"
                rules={[
                  {
                    required: false,
                    message: "Required",
                  },
                ]}
              >
                <DatePicker
                  format={"YYYY-MM-DD"}
                  size="large"
                  style={{ width: "100%" }}
                  // showTime
                />
              </Form.Item>

              {allowAttendance && (
                <>
                  <Form.Item
                    name="salary_sched"
                    label="Salary Schedule"
                    rules={[
                      {
                        required: allowAttendance ? true : false,
                        message: "Required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select schedule"
                      size="large"
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={(e) => setSelectedSchedule(e)}
                    >
                      <Select.Option value={"daily"}>Daily</Select.Option>
                      <Select.Option value={"monthly"}>Monthly</Select.Option>
                    </Select>
                  </Form.Item>

                  {selectedSchedule === "monthly" && (
                    <Form.Item
                      name="salary_pay_count"
                      label={"Pay count in 1 Month"}
                      rules={[
                        {
                          required: true,
                          message: "Required",
                        },
                      ]}
                    >
                      <InputNumber
                        min={1}
                        max={999999999999}
                        initialvalues={0}
                        size="large"
                        style={{ width: "100%" }}
                        step="1"
                      />
                    </Form.Item>
                  )}

                  <Form.Item
                    name="amount"
                    label={
                      selectedSchedule === "daily" ? "Daily Pay" : "Monthly Pay"
                    }
                    rules={[
                      {
                        required: true,
                        message: "Required",
                      },
                    ]}
                  >
                    <InputNumber
                      min={1}
                      max={999999999999}
                      initialvalues={0}
                      size="large"
                      style={{ width: "100%" }}
                      step="0.01"
                    />
                  </Form.Item>
                </>
              )}
            </Space>

            <Form.Item style={{ marginTop: "20px" }}>
              <Button
                type="primary"
                loading={loadingsInfo}
                htmlType="submit"
                style={{ width: "100%", borderRadius: "20px" }}
              >
                {loadingsInfo ? "Loading" : "Update Info"}
              </Button>
            </Form.Item>
          </Form>
          <Divider style={{ border: "2px solid #000" }} />
          <Form
            style={{ marginTop: 20 }}
            layout="vertical"
            name="edit-employee-credential"
            initialValues={{
              username: selectedData.merchantemployeeusers.username,
              password: "",
            }}
            onFinish={handleEditEmployeeCredential}
            autoComplete="off"
          >
            <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
              <Typography
                style={{ marginBottom: 10, fontSize: 16, fontWeight: "bold" }}
              >
                CREDENTIALS
              </Typography>
              <Form.Item
                name="username"
                label="Username"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Set username" size="large" />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "5px" }}
                name="password"
                label="Password"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input.Password placeholder="Set password" size="large" />
              </Form.Item>
            </Space>

            <Form.Item style={{ marginTop: "20px" }}>
              <Button
                type="primary"
                loading={loadingsCred}
                htmlType="submit"
                style={{ width: "100%", borderRadius: "20px" }}
              >
                {loadingsCred ? "Loading" : "Update Credential"}
              </Button>
            </Form.Item>
          </Form>

          {allowAttendance && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Divider style={{ border: "2px solid #000" }} />
              <Typography
                style={{ marginBottom: 10, fontSize: 16, fontWeight: "bold" }}
              >
                ATTENDANCE
              </Typography>

              <Typography style={{ marginTop: 10, marginBottom: 5 }}>
                RFID Code
              </Typography>

              <Input
                size="large"
                value={
                  selectedData.rfid_code !== null ? selectedData.rfid_code : ""
                }
              />

              <Button
                type="primary"
                // loading={loadingsRFID}
                // htmlType="submit"
                style={{
                  width: "100%",
                  borderRadius: "20px",
                  marginTop: "20px",
                }}
                onClick={() => {
                  setCreateRFIDDiag(true);
                }}
              >
                {selectedData.rfid_code !== null
                  ? "Update RFID"
                  : "Create RFID"}
              </Button>
            </div>
          )}
        </>
      )}

      <Modal
        title=""
        open={createRFIDDiag}
        onCancel={() => {
          setCreateRFIDDiag(false);
          close();
          rerun();
        }}
        footer={null}
        width={350}
        centered
        getContainer={false}
      >
        <CreateNewRFID
          close={() => setCreateRFIDDiag(false)}
          closeOriginDrawer={() => {
            close();
            rerun();
          }}
          selectedData={selectedData}
        />
      </Modal>
    </Drawer>
  );
};

export default EditEmployee;
